<template>
    <div>
    <el-dialog title="编辑" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form" ref="form" :rules="formRules">
            <el-form-item label="名称" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item>
            
            <el-form-item label="说明" :label-width="formLabelWidth">
                <el-input v-model="form.intro" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="未激活图片" :label-width="formLabelWidth">
                <el-button type="primary" @click="openUpload('image')">上传图片</el-button>
                <img class="mt10" v-if="form.image" :src="form.image"  width="120px;" alt="" />
            </el-form-item>

            <el-form-item label="已激活图片" :label-width="formLabelWidth">
                <el-button type="primary" @click="openUpload('act_image')">上传图片</el-button>
                <img class="mt10" v-if="form.act_image" :src="form.act_image"  width="120px;" alt="" />
            </el-form-item>

            <el-form-item label="键值" :label-width="formLabelWidth">
                <el-input v-model="form.key_name" autocomplete="off"></el-input>
            </el-form-item>
            
            <el-form-item label="状态" :label-width="formLabelWidth">
                <el-radio-group v-model="form.status">
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editCategory" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    </div>
</template>

<script>
import CodeApi from '@/api/study/code.js';
import Upload from '@/components/file/Upload';
export default {
    components: {
        Upload,
    },
    data() {
        return {
            /*左边长度*/
            formLabelWidth: '120px',
            /*是否显示*/
            dialogVisible: false,
            loading: false,
            isupload: false,
            type: '',
            formRules: {
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
                code_count: [{ type: 'number', required: true, message: '请输入数量' }, { type: 'number', min: 1, message: '请数量大于0' }],
                role_ids: [{ required: true, message: '请选择角色', trigger: 'blur' }],
            },
        };
    },
    props: ['open_edit', 'form'],
    created() {
        this.dialogVisible = this.open_edit;
    },
    methods: {
        /*修改分类*/
        editCategory() {
            let self = this;
            let params = this.form;
            self.loading = true;
            CodeApi.edit(params, true)
                .then(data =>
                {
                    self.loading = false;
                    self.$message({
                        message: '恭喜你，修改成功',
                        type: 'success'
                    });
                    self.dialogFormVisible(true);

                })
                .catch(error =>
                {
                    self.loading = false;
                });
        },

        /*关闭弹窗*/
        dialogFormVisible(e) {
            if (e) {
                this.$emit('closeDialog', {
                    type: 'success',
                    openDialog: false
                })
            } else {
                this.$emit('closeDialog', {
                    type: 'error',
                    openDialog: false
                })
            }
        },

        /*上传*/
        openUpload(e) {
            this.type = e;
            this.isupload = true;
        },
        /*获取图片*/
        returnImgsFunc(e) {
            if (e != null) {
                this.form[this.type] = e[0].file_path;
                this.form[this.type+'_id'] = e[0].file_id;
            }
            this.isupload = false;
        },

    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/code/code/part/Edit.vue